import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ArchiveIcon } from 'assets';
import { useArchiveScorecardRow } from 'hooks';

interface ArchiveRowButtonProps {
    rowId: number;
    archived: boolean;
    disabled?: boolean;
}

export const ArchiveRowButton: React.FC<ArchiveRowButtonProps> = ({ rowId, archived, disabled = false }) => {
    const { mutateAsync: archiveRow, isLoading: isArchiving } = useArchiveScorecardRow();

    const handleArchiveRow = async () => {
        try {
            await archiveRow({ id: rowId, archived: !archived });
        } catch (error) {
            // Error handling is done in the mutation hook
        }
    };

    const tooltipTitle = archived ? 'Restore' : 'Archive row';
    const iconColor = archived ? '#46A314' : undefined;
    const iconStyle = archived ? {
        transform: 'rotate(180deg)',
        fill: 'transparent'
    } : {};

    return (
        <Tooltip
            arrow
            placement="top"
            title={tooltipTitle}>
            <IconButton
                size="small"
                onClick={handleArchiveRow}
                disabled={disabled || isArchiving}
                sx={{
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }}
            >
                <ArchiveIcon
                    color={iconColor}
                    style={{
                        width: '16px',
                        height: '16px',
                        ...iconStyle
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};
